
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/advanced-automation",
      function () {
        return require("private-next-pages/guides/advanced-automation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/advanced-automation"])
      });
    }
  